// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main-module__frame-Main--wuRds {}`, "",{"version":3,"sources":["webpack://./src/frames/Main/Main.module.css"],"names":[],"mappings":"AAAA,iCAAa","sourcesContent":[".frame-Main {}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame-Main": `Main-module__frame-Main--wuRds`
};
export default ___CSS_LOADER_EXPORT___;
